import * as React from 'react'
import styled, { css } from 'styled-components'
import Utils from '../../../utilities/Utils'

export const Container = styled.div<{ width?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  color: #ffffff;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 0 0 2px rgb(255, 255, 255);
  color: white;
	background: #63778b;
  font-weight: bold;
  font-size: 10px;
  text-transform: uppercase;

  ${({ width }) => css`
    width: ${width}px;
    height: ${width}px;
    font-size: ${width / 2.4}px;
  `}

  img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

interface IProps {
  width?: number
  src?: string
  name: string
}

const Avatar = (props: IProps) => {
  const { name, width, src } = props
  return (
    <Container width={width}>
      {src?.length > 0 && <img src={src} />}
      {(src?.length === 0 || !src) ? Utils.getInitials(name) : null}
    </Container>
  )

}

export default Avatar